import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

import { fieldSSTStyles, InputComponentTextStyles } from 'inquiry/mixins/form';
import FormControlProps from 'lib/interfaces/FormControlProps';

export type StyledInputProps = ComponentPropsWithoutRef<'input'> &
  FormControlProps & { styles?: InputComponentTextStyles };

const ThemedFormInputBaseInner = styled('input').attrs<StyledInputProps>({
  // Avoid spell-jacking
  spellCheck: false,
})<StyledInputProps>`
  ${(props) => fieldSSTStyles(props, props.theme, props.styles)};
`;

export default function ThemedFormInputBase(props: StyledInputProps) {
  return <ThemedFormInputBaseInner {...props} />;
}
